import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Landscape from './Landscape';
import StagingManager from './Staging/StagingManager';
import TargetGroupsScreen from './TargetGroups/TargetGroupsScreen';
import SubsetEditor from './Subsets/SubsetEditor';
import ProvisionScreen from './Subsets/ProvisionScreen';
import RunDetail from './Subsets/RunDetail';
import TdmLicenseGate from './TdmLicenseGate';
import './TestDataManagement.css';
// The subset editor and target groups reuse the Data Graph's dg-* table classes; the Data Graph
// itself moved to the operator console, so its stylesheet is loaded here too.
import 'DataGraph/DataGraph.css';

// Route shell for Test Data Management: the landscape home (subsets), staging areas, target
// groups, the subset editor, the per-subset provision screen and one subset run in full (run lists
// elsewhere carry summaries; /runs/:runId fetches the whole run). Every route sits behind
// TdmLicenseGate — an unlicensed `tdm` feature shows one not-licensed panel instead of 403s.
// Note the subset routes: /subsets/new must precede /subsets/:id or the editor never matches.
const TestDataManagement = () => {
  const { path } = useRouteMatch();
  return (
    <div className='p-0'>
      <Container className='h-100' fluid>
        <Row>
          <Col className='p-0'>
            <TdmLicenseGate>
            <Switch>
              <Route exact path={`${path}`}><Landscape /></Route>
              <Route exact path={`${path}/staging`}><StagingManager /></Route>
              <Route exact path={`${path}/target-groups`}><TargetGroupsScreen /></Route>
              <Route exact path={`${path}/subsets/new`}><SubsetEditor /></Route>
              <Route exact path={`${path}/subsets/:id/provision`}><ProvisionScreen /></Route>
              <Route exact path={`${path}/subsets/:id`}><SubsetEditor /></Route>
              <Route exact path={`${path}/runs/:runId`}><RunDetail /></Route>
            </Switch>
            </TdmLicenseGate>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TestDataManagement;
